export type ResetPasswordFormEventsName = 'reset' | 'backToLogin' | 'resetSuccess' | 'resetError' | 'open';

export const ResetPasswordEvents: Record<ResetPasswordFormEventsName, any> = {
  open: 'page__opened',
  reset: 'page__login_with_new_password_button_click',
  backToLogin: 'page__back_to_login_link_click',
  resetSuccess: 'page__login_with_new_password_success',
  resetError: 'page__login_with_new_password_error',
}
